import {$} from '../jquery-definition.js';
import 'jquery.equalheights';

$( function() {
	$( '.equal-heights' ).equalHeights( {
		wait: true,
		watch: true,
	} );

	$( '.equal-height-slider' ).each( function() {
		const $this = $( this );

		const contentHeight = $this.prev().outerHeight();
		$this.height( contentHeight );
	} );
} );
